import { Trans } from 'react-i18next';
import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Link from 'Components/shared/Link/Link';
import { PATHS } from 'Libraries/routes.library';
import { t } from 'i18next';
import { IApplicationState } from '@spinwise/spinwise-core';
import styles from './ProviderBlock.module.scss';

const Background = dynamic(() => import('./Background/Background'), { ssr: false });

interface IProviderBlock {
  regtype?: string;
}

const ProviderBlock = (props: IProviderBlock) => {
  const code = useSelector((state: IApplicationState) => state.globalReducer.geo.code);
  const reg_type = useSelector((state: IApplicationState) => state.globalReducer.geo.reg_type);

  const [regType, setRegType] = useState(props.regtype);
  const [hasMounted, setHasMounted] = useState(false);

  const getPromoText = (value: String) => {
    if (['SWE', 'NOR'].includes(code)) {
      return t(`swe.${regType}.${value}`);
    }
    return t(`${regType}.${value}`);
  };

  useEffect(() => {
    if (reg_type && reg_type !== regType) {
      setRegType(reg_type);
    }
  }, [reg_type, regType]);

  useEffect(() => {
    setHasMounted(true);
  }, []);

  return (
    <>
      {hasMounted == true && (
        <div className={`${styles.provider_main_container}`}>
          <Background />
          <div className={`${styles.content_container} d-fl jc-c`}>
            <p className={`${styles.title} d-fl`}>
              <Trans components={{}} transKeepBasicHtmlNodesFor>
                homepage.c2.title.1.before.games
              </Trans>
            </p>
            <Link className={`${styles.button_container} d-fl ai-c jc-c`} href={PATHS.GAMES}>
              <div className={`${styles.game_button} d-fl ai-c`}>
                <p>{getPromoText('homepage.c2.provider.button')}</p>
              </div>
            </Link>
          </div>
        </div>
      )}
    </>
  );
};
export default ProviderBlock;
